<template>
    <div class="modal right social-wall-add-photo" id="social-wall-add-photo">
        <div class="bg-modal" :class="{show: submitted}" :style="`background-image: url(${this.urlBackground});`"></div>
        <div class="close-button" @click.stop="close">
            <span class="icon-cross"></span>
            Fermer
        </div>
        <div class="content mCustomScrollbar">
            <!--ScrollBar-->
            <transition mode="out-in">
                <div class="div-anim" v-if="submitted" key="confirmation">
                    <p class="margin"></p>
                    <p class="merci">Merci !</p>
                    <p class="okmsg">Votre photo sera plubliée après validation par nos équipes.</p>
                    <a href="#" class="btn chevron outline goback" @click.prevent="close">Retour</a>
                </div>

                <div class="div-anim" v-else-if="uploading" key="upload">
                    <p class="margin"></p>
                    <p class="merci">Envoi en cours</p>
                    <progress :value="uploadProgress" v-if="uploadProgress < 1">
                        {{ uploadProgress * 100 }}%
                    </progress>
                    <progress v-else></progress>
                    <p class="okmsg">Votre photo est en cours d'envoi. Merci de patienter.</p>
                </div>

                <form class="div-anim" @submit.prevent="submit" v-else key="form">

                    <h2 class="titre">Publiez votre photo</h2>

                    <div class="row dropzone-row">
                        <div class="col-12 col-lg-4"><p class="label">Votre photo</p></div>
                        <div class="col-12 col-lg-8 col-dropzone">
                            <div class="dropzone"
                                 :class="{'dragging-over': draggingOver}"
                                 :style="{backgroundImage: `url(${thumbnail})`}"
                                 @drop.prevent="onDrop"
                                 @dragover.prevent="draggingOver = true"
                                 @dragleave="draggingOver = false">
                                <div class="dz-message" v-show="!form.photo">
                                    <label class="btn">
                                        Ajouter ma photo <span class="icon-picto-add-photo"></span>
                                        <input type="file"
                                               accept="image/jpeg,image/png"
                                               @change="addFile($event.target.files[0])">
                                    </label>
                                    <p class="drop-legend">
                                        Poids max du fichier : 8 Mo<br>
                                        Format JPG ou PNG uniquement
                                    </p>
                                </div>
                            </div>
                            <p v-for="error in errors.get('photo')">{{ error }}</p>
                            <button type="button" class="kill-photo" @click="deleteFile()">x Supprimer</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-4"><p class="label">À propos :</p></div>
                        <div class="col-12 col-lg-8 col-infos">
                            <custom-select class="pin"
                                           :options="destinations"
                                           value-field="term_id"
                                           label-field="name"
                                           v-model="form.destination"
                                           @change="errors.clear('destination')">
                            </custom-select>
                            <p v-for="error in errors.get('destination')">{{ error }}</p>
                            <div class="form-item">
                                <label for="prenom">Prénom</label>
                                <input type="text"
                                       id="prenom"
                                       required
                                       v-model="form.first_name"
                                       @input="errors.clear('first_name')">
                                <p v-for="error in errors.get('first_name')">{{ error }}</p>
                            </div>
                            <div class="form-item">
                                <label for="city">Ville</label>
                                <input type="text"
                                       id="city"
                                       required
                                       v-model="form.city"
                                       @input="errors.clear('city')">
                                <p v-for="error in errors.get('city')">{{ error }}</p>
                            </div>
                            <p class="infos-commentaire">
                                Commentaire à propos de la photo (facultatif)<br>
                                300 caractères max.
                            </p>
                            <div class="form-item textarea infos">
                                <label for="commentaire"></label>
                                <textarea id="commentaire"
                                          maxlength="300"
                                          v-model="form.comment"
                                          @input="errors.clear('comment')"></textarea>
                                <p v-for="error in errors.get('comment')">{{ error }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="cta">
                        <button type="submit" class="btn chevron">Envoyer</button>
                    </div>
                </form>
            </transition>

        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    import $ from 'jquery';
    import Errors from '../../Errors';
    import Modal from '../../libs/Modal';

    export default {
        props: {
            destinations: {
                type: Array,
                required: true,
            },
            urlBackground: {
                type: String,
                required: false,
            },
        },
        data() {
            return {
                step: 1,
                draggingOver: false,
                thumbnail: '',
                submitted: false,
                uploading: false,
                uploadProgress: 0,
                errors: new Errors(),
                form: {
                    action: 'ge_social_wall_add_photo',
                    photo: null,
                    destination: this.destinations[0].term_id,
                    first_name: '',
                    city: '',
                    comment: '',
                },
            };
        },
        methods: {
            onDrop(event) {
                this.draggingOver = false;
                this.addFile(event.dataTransfer.files[0]);
            },
            /**
             * @param {File} file
             */
            addFile(file) {
                if (!this.check(file)) {
                    return;
                }
                this.deleteFile();
                this.thumbnail = URL.createObjectURL(file);
                this.form.photo = file;
            },
            deleteFile() {
                URL.revokeObjectURL(this.thumbnail);
                this.thumbnail = '';
                this.form.photo = null;
            },
            check(file) {
                this.errors.clear('photo');

                if (!['image/jpeg', 'image/png'].includes(file.type)) {
                    this.errors.add('photo', 'Le format de l\'image doit être JPG ou PNG.');
                }
                if (file.size > 8000000) {
                    this.errors.add('photo', 'L\'image ne doit pas peser plus de 8 Mo.');
                }

                return !this.errors.has('photo');
            },
            submit() {
                this.uploading = true;
                this.errors.clear();
                let data = new FormData();
                Object.keys(this.form).forEach(key => data.append(key, this.form[key]));
                let config = {
                    withCredentials: true,
                    /**
                     * @param {ProgressEvent} progressEvent
                     */
                    onUploadProgress: progressEvent => {
                        if (progressEvent.lengthComputable) {
                            this.uploadProgress = progressEvent.loaded / progressEvent.total;
                        }
                    },
                };
                return axios.post(window.GrandsEspaces.adminUrl, data, config)
                    .then(() => {
                        this.uploading = false;
                        this.submitted = true;
                        this.reset();
                    })
                    .catch(({response}) => {
                        this.uploading = false;
                        this.errors.record(response.data.errors);
                    });
            },
            reset() {
                this.deleteFile();
                this.form = {
                    action: 'ge_social_wall_add_photo',
                    photo: null,
                    destination: this.destinations[0].term_id,
                    first_name: '',
                    city: '',
                    comment: '',
                };
            },
            close() {
                this.submitted = false;
                Modal.hideModal('#social-wall-add-photo');
            },
        },
    };
</script>


// WEBPACK FOOTER //
// assets/js/components/social-wall/SocialWallAddPhoto.vue